<template>
  <v-col cols="12" sm="10" md="6" class="text-center my-6">
    <h1 class="text-h5 align-center mb-6 secondary--text">
      <!-- <v-icon left color="accent">mdi-account-circle-outline</v-icon> -->
      <span class="accent--text">Author: </span>
      <span v-html="name"></span>
    </h1>
    <p class="grey--text text--darken-1 mb-6 mx-auto" v-html="description" v-if="description" style="max-width: 720px;">
      Accumsan dignissim suscipit accumsan eleifend curae cum ultrices posuere a vestibulum a magnis metus ullamcorper donec augue a curabitur
    </p>
    <!-- <v-divider></v-divider> -->
  </v-col>
</template>

<script>
  export default {
    name: 'TagHeader',

    props: {
      name: {
        type: String,
        default: 'Tag'
      },
      description: {
        type: String,
        default: 'lorem ipsum dolor est amit'
      },
      image: {
        type: String,
        default: ''
      }
    }
  }
</script>
